import { yupResolver } from "@hookform/resolvers/yup";
import { FormEventHandler, forwardRef } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { ObjectSchema } from "yup";

export interface IFormValues {
  fullName?: string;
  email?: string;
  phoneNumber?: string;
  datepicker?: string;
  adults?: number;
  teens?: number;
  children?: number;
  rooms?: number;
  budgets?: {
    min: number;
    max: number;
  };
}

interface IForm {
  validationSchema: ObjectSchema<any>;
  defaultValues?: any;
  children: JSX.Element | JSX.Element[];
  submitHandler?: (data: any) => Promise<void>;
  action?: string;
}

const Form = (
  { validationSchema, defaultValues, children, submitHandler, action }: IForm,
  _ref?: React.Ref<HTMLFormElement>
): JSX.Element => {
  const formProps = useForm<IFormValues>({
    defaultValues,
    resolver: yupResolver(validationSchema),
    shouldFocusError: true,
  });

  const onSubmit = (data: any): void => {
    if (submitHandler !== null && submitHandler !== undefined) {
      submitHandler(data).catch(() => {});
      formProps.reset(defaultValues);
    }
  };

  return (
    <FormProvider {...formProps}>
      <form
        ref={_ref}
        noValidate
        onSubmit={formProps.handleSubmit(onSubmit) as FormEventHandler}
        className="top-0 z-[60] w-full scrollbar-hide"
        action={action}
      >
        {children}
      </form>
    </FormProvider>
  );
};

const ForwardedRefForm = forwardRef(Form);

export default ForwardedRefForm;
